import { render, staticRenderFns } from "./LeftPartMessage.vue?vue&type=template&id=0b2dd8b4&scoped=true"
import script from "./LeftPartMessage.vue?vue&type=script&lang=js"
export * from "./LeftPartMessage.vue?vue&type=script&lang=js"
import style0 from "./LeftPartMessage.vue?vue&type=style&index=0&id=0b2dd8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2dd8b4",
  null
  
)

export default component.exports